import type { ReactElement } from 'react';
import React from 'react';
import { ChevronRightIcon } from '@balance-web/icon';
import { Flex } from '@balance-web/flex';
import { Inline } from '@balance-web/inline';
import { Text } from '@balance-web/text';
import { flattenElements } from '@balance-web/utils';

import { BreadCrumbTextItem } from './BreadCrumbTextItem';
import type { BreadCrumbTextItemProps } from './BreadCrumbTextItem';
import { BreadCrumbButton } from './BreadCrumbButton';
import type { BreadCrumbButtonProps } from './BreadCrumbButton';
import type { BreadCrumbLinkProps } from './BreadCrumbLink';
import { BreadCrumbLink } from './BreadCrumbLink';

export type BreadCrumbsProps = {
  children:
    | ReactElement<BreadCrumbTextItemProps>
    | (null | ReactElement<BreadCrumbTextItemProps>)[]
    | ReactElement<BreadCrumbLinkProps>
    | (null | ReactElement<BreadCrumbLinkProps>)[]
    | ReactElement<BreadCrumbButtonProps>
    | (null | ReactElement<BreadCrumbButtonProps>)[];
};

export const BreadCrumbs = ({ children }: BreadCrumbsProps) => {
  const childArray = flattenElements(children);

  return (
    <nav aria-label="Breadcrumb">
      <Inline as="ol">
        {childArray.map((child, index) => {
          return (
            <Inline key={child.props.href || Math.random()} as="li">
              {index ? (
                <Flex paddingX="xsmall">
                  <ChevronRightIcon color="dim" size="small" />
                </Flex>
              ) : null}

              {index < childArray.length - 1 ? (
                child
              ) : (
                <Text size="xsmall">{child.props.children}</Text>
              )}
            </Inline>
          );
        })}
      </Inline>
    </nav>
  );
};

BreadCrumbs.Item = BreadCrumbLink;
BreadCrumbs.TextItem = BreadCrumbTextItem;
BreadCrumbs.Button = BreadCrumbButton;
